import { SORT_ORDER } from '@/helpers/constants'
import type { SortOrder } from '@/helpers/types'
import { useCallback, useState } from 'react'

export const useSortOrder = () => {
  const [sortOrder, setSortOrder] = useState<SortOrder>(SORT_ORDER.ASC)

  const toggleSortOrder = useCallback(() => {
    // Optimistically update the UI
    setSortOrder(prev => {
      return prev === SORT_ORDER.ASC ? SORT_ORDER.DESC : SORT_ORDER.ASC
    })
  }, [])

  return {
    sortOrder,
    toggleSortOrder,
  }
}
